// package: app.portal.gloo.solo.io
// file: web_app_grpc.proto

var web_app_grpc_pb = require("./web_app_grpc_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var github_com_solo_io_dev_portal_api_dev_portal_v1beta1_common_common_pb = require("./github.com/solo-io/dev-portal/api/dev-portal/v1beta1/common/common_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var WebAppApi = (function () {
  function WebAppApi() {}
  WebAppApi.serviceName = "app.portal.gloo.solo.io.WebAppApi";
  return WebAppApi;
}());

WebAppApi.Login = {
  methodName: "Login",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: web_app_grpc_pb.LoginRequest,
  responseType: web_app_grpc_pb.LoginResponse
};

WebAppApi.Logout = {
  methodName: "Logout",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: google_protobuf_empty_pb.Empty
};

WebAppApi.GetCurrentUser = {
  methodName: "GetCurrentUser",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.GetCurrentUserResponse
};

WebAppApi.GetPortalSummary = {
  methodName: "GetPortalSummary",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.GetPortalSummaryResponse
};

WebAppApi.ChangePassword = {
  methodName: "ChangePassword",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: web_app_grpc_pb.ChangePasswordRequest,
  responseType: google_protobuf_empty_pb.Empty
};

WebAppApi.GetCustomStyling = {
  methodName: "GetCustomStyling",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.GetCustomStylingResponse
};

WebAppApi.GetPageExtensions = {
  methodName: "GetPageExtensions",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.GetPageExtensionsResponse
};

WebAppApi.GetStaticPages = {
  methodName: "GetStaticPages",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.GetStaticPagesResponse
};

WebAppApi.GetDynamicPages = {
  methodName: "GetDynamicPages",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.GetDynamicPagesResponse
};

WebAppApi.ListAPIProducts = {
  methodName: "ListAPIProducts",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.APIProductListResponse
};

WebAppApi.GetAPIProductDetails = {
  methodName: "GetAPIProductDetails",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: github_com_solo_io_dev_portal_api_dev_portal_v1beta1_common_common_pb.ObjectRef,
  responseType: web_app_grpc_pb.APIProductDetails
};

WebAppApi.GetAPIProductVersionDetails = {
  methodName: "GetAPIProductVersionDetails",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: web_app_grpc_pb.APIProductVersionDetailsRequest,
  responseType: web_app_grpc_pb.APIProductVersionDetails
};

WebAppApi.ListAPIProductPlans = {
  methodName: "ListAPIProductPlans",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: web_app_grpc_pb.APIProductPlansListResponse
};

WebAppApi.ListAPIProductPlanDetails = {
  methodName: "ListAPIProductPlanDetails",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: github_com_solo_io_dev_portal_api_dev_portal_v1beta1_common_common_pb.ObjectRef,
  responseType: web_app_grpc_pb.APIProductPlanDetailsListResponse
};

WebAppApi.AddAPIKey = {
  methodName: "AddAPIKey",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: web_app_grpc_pb.AddAPIKeyRequest,
  responseType: web_app_grpc_pb.AddAPIKeyResponse
};

WebAppApi.DeleteAPIKey = {
  methodName: "DeleteAPIKey",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: github_com_solo_io_dev_portal_api_dev_portal_v1beta1_common_common_pb.ObjectRef,
  responseType: google_protobuf_empty_pb.Empty
};

WebAppApi.InvokeGRPCMethod = {
  methodName: "InvokeGRPCMethod",
  service: WebAppApi,
  requestStream: false,
  responseStream: false,
  requestType: web_app_grpc_pb.GRPCInvokeRequest,
  responseType: web_app_grpc_pb.GRPCInvokeResponse
};

exports.WebAppApi = WebAppApi;

function WebAppApiClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

WebAppApiClient.prototype.login = function login(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.Login, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.logout = function logout(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.Logout, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getCurrentUser = function getCurrentUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetCurrentUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getPortalSummary = function getPortalSummary(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetPortalSummary, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.changePassword = function changePassword(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.ChangePassword, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getCustomStyling = function getCustomStyling(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetCustomStyling, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getPageExtensions = function getPageExtensions(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetPageExtensions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getStaticPages = function getStaticPages(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetStaticPages, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getDynamicPages = function getDynamicPages(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetDynamicPages, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.listAPIProducts = function listAPIProducts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.ListAPIProducts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getAPIProductDetails = function getAPIProductDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetAPIProductDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.getAPIProductVersionDetails = function getAPIProductVersionDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.GetAPIProductVersionDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.listAPIProductPlans = function listAPIProductPlans(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.ListAPIProductPlans, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.listAPIProductPlanDetails = function listAPIProductPlanDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.ListAPIProductPlanDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.addAPIKey = function addAPIKey(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.AddAPIKey, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.deleteAPIKey = function deleteAPIKey(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.DeleteAPIKey, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WebAppApiClient.prototype.invokeGRPCMethod = function invokeGRPCMethod(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(WebAppApi.InvokeGRPCMethod, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.WebAppApiClient = WebAppApiClient;

